/**
* Returns a driving event types based on the provided event
* @param  {String} event A particular driving event
* @return {Mixed}       Can be a typeof Boolean, String or even Object
*/
var eventTypes = function( event ) {
    "use strict";
    var output = {
        event: event,
        name: event,
        status: false
    };

    /**
     * Duty Status Change
     * @return null
     */

    function onDuty() {
        switch ( event ) {
            case "OnDuty":
                output.status = true;
                output.name = "OnDuty ND";
                break;
            // No default
        }

        return output;
    }

    function offDuty() {
        switch ( event ) {
            case "OffDuty":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function sleeper() {
        switch ( event ) {
            case "Sleeper":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function driving() {
        switch ( event ) {
            case "Driving":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    /**
     * Extra Events for VisTracks use
     * @return null
     */

    function waitingAtSite() {
        switch ( event ) {
            case "WaitingAtSite":
                output.status = true;
                break;
             // No default
        }

        return output;
    }

    function offRoad() {
        switch ( event ) {
            case "OffRoad":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function onRoad() {
        switch ( event ) {
            case "OnRoad":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function remark() {
        switch ( event ) {
            case "Remark":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function intermediate() {
        switch ( event ) {
            case "Inter":
            case "InterRP":
                output.status = true;
                break;
            // No default
        }

        return output;
    }



    /**
     * Personal Conveyance and Yard Moves
     * @return null
     */

    function yardMoves() {
        switch ( event ) {
            case "YM":
            case "YardMoves":
                output.status = true;
                output.name = "YardMoves";
                break;
            // No default
        }

        return output;
    }

    function personalUse() {
        switch ( event ) {
            case "PC":
            case "PersonalConveyance":
            case "PersonalUse":
                output.status = true;
                output.name = "PersonalUse";
                break;
            // No default
        }

        return output;
    }

    function clearPCorYM() {
        switch ( event ) {
            case "ClearPCYM":
            case "ClearPCorYM":
                output.status = true;
                output.name = "ClearPCYM";
                break;
            // No default
        }

        return output;
    }

    function clearYM() {
        switch ( event ) {
            case "ClearYM":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function clearPC() {
        switch ( event ) {
            case "ClearPC":
            case "ClearPU":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    /**
     * Certification
     * @return null
     */

    function certify() {
        switch ( event ) {
            case "Certify":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    /**
     * Login or Logout
     * @return null
     */
    function login() {
        switch ( event ) {
            case "Login":
                output.status = true;
                output.name = "ELD Login";
                break;
            // No default
        }

        return output;
    }

    function logout() {
        switch ( event ) {
            case "Logout":
                output.status = true;
                output.name = "ELD Logout";
                break;
            // No default
        }

        return output;
    }

    /**
     * Power Cycle
     * @return null
     */
    function powerOff() {
        switch ( event ) {
            case "PowerOff":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function powerOn() {
        switch ( event ) {
            case "PowerOn":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function powerOffRp() {
        switch ( event ) {
            case "PowerOffRP":
                output.status = true;
                break;
            // No default
        }

        return output;
    }

    function powerOnRp() {
        switch ( event ) {
            case "PowerOnRP":
                output.status = true;
                break;
            // No default
        }

        return output;
    }


    /**
     * Diagnostic Events & Malfunctions
     * @return null
     */
    function malPower() {
        switch ( event ) {
            case "MalPower":
                output.status = true;
                output.eventCode = "Pow MF";
                output.eventName = "Power Malfunction";
                break;
            // No default
        }

        return output;
    }

    function malSync() {
        switch ( event ) {
            case "MalSync":
                output.status = true;
                output.eventCode = "Sync MF";
                output.eventName = "Engine Synchronization Malfunction";
                break;
            // No default
        }

        return output;
    }

    function malTime() {
        switch ( event ) {
            case "MalTime":
                output.status = true;
                output.eventCode = "Timing MF";
                output.eventName = "Timing Malfunction";
                break;
            // No default
        }
        return output;
    }

    function malPos() {
        switch ( event ) {
            case "MalPos":
                output.status = true;
                output.eventCode = "Pos MF";
                output.eventName = "Position Malfunction";
                break;
            // No default
        }
        return output;
    }

    function malRecord() {
        switch ( event ) {
            case "MalRecord":
                output.status = true;
                output.eventCode = "DR MF";
                output.eventName = "Position Malfunction";
                break;
            // No default
        }
        return output;
    }

    function malTransfer() {
        switch ( event ) {
            case "MalTransfer":
                output.status = true;
                output.eventCode = "Trans MF";
                output.eventName = "Data Transfer Malfunction";
                break;
            // No default
        }
        return output;
    }

    function malOther() {
        switch ( event ) {
            case "MalOther":
                output.status = true;
                output.eventCode = "Other MF";
                output.eventName = "Other Malfunction";
                break;
            // No default
        }
        return output;
    }

    function diagPower() {
        switch ( event ) {
            case "DiagPower":
                output.status = true;
                output.eventCode = "Pwd Diag";
                output.eventName = "Power Diagnostic";
                break;
            // No default
        }
        return output;
    }

    function diagSync() {
        switch ( event ) {
            case "DiagSync":
                output.status = true;
                output.eventCode = "Sync Diag";
                output.eventName = "Engine Synchronization Diagnostic";
                break;
            // No default
        }
        return output;
    }

    function diagMissing() {
        switch ( event ) {
            case "DiagMissing":
                output.status = true;
                output.eventCode = "Miss Diag";
                output.eventName = "Missing Required Data Elements Diagnostic";
                break;
            // No default
        }
        return output;
    }

    function diagTransfer() {
        switch ( event ) {
            case "DiagTransfer":
                output.status = true;
                output.eventCode = "Tran Diag";
                output.eventName = "Data Transfer Diagnostic";
                break;
            // No default
        }
        return output;
    }

    function diagUnidentified() {
        switch ( event ) {
            case "DiagUnidentified":
                output.status = true;
                output.eventCode = "Unid Diag";
                output.eventName = "Unidentified Driver Diagnostic";
                break;
            // No default
        }
        return output;
    }

    function diagOther() {
        switch ( event ) {
            case "DiagOther":
                output.status = true;
                output.eventCode = "Other Diag";
                output.eventName = "Other Diagnostic";
                break;
            // No default
        }
        return output;
    }

    function drivingEvents() {
        return onDuty().status ||
            offDuty().status ||
            sleeper().status ||
            driving().status ||
            waitingAtSite().status ||
            yardMoves().status ||
            personalUse().status ||
            clearPC().status ||
            clearYM().status;
    }

    function primaryEventStatus() {
        return onDuty().status ||
            remark().status ||
            sleeper().status ||
            certify().status ||
            offDuty().status ||
            yardMoves().status ||
            waitingAtSite().status ||
            offRoad().status ||
            login().status ||
            driving().status ||
            personalUse().status ||
            onRoad().status ||
            powerOn().status ||
            powerOff().status ||
            powerOffRp().status ||
            powerOnRp().status ||
            intermediate().status ||
            clearPC().status ||
            clearYM().status ||
            logout().status;
    }

    function intermediateEvents() {
        return intermediate().status;
    }

    function list () {
        switch ( event ) {
            case "OnDuty":
                output.name = onDuty().name;
                break;
            case "YardMoves":
            case "YM":
                output.name = yardMoves().name;
                break;
            case "PersonalConveyance":
            case "PersonalUse":
            case "PC":
                output.name = personalUse().name;
                break;
            case "ClearPCorYM":
            case "ClearPCYM":
                output.name = clearPCorYM().name;
                break;
            case "Login":
            case "ELD Login":
                output.name = login().name;
                break;
            case "Logout":
            case "ELD Logout":
                output.name = logout().name;
                break;
            default:
                output.name = event;
                break;
        }

        return output.name;
    }

    function get() {
        switch ( event ) {
            case "MalPower":
                event = malPower();
                break;
            case "MalSync":
                event = malSync();
                break;
            case "MalTime":
                event = malTime();
                break;
            case "MalPos":
                event = malPos();
                break;
            case "MalRecord":
                event = malRecord();
                break;
            case "MalTransfer":
                event = malTransfer();
                break;
            case "MalOther":
                event = malOther();
                break;
            case "DiagPower":
                event = diagPower();
                break;
            case "DiagSync":
                event = diagSync();
                break;
            case "DiagMissing":
                event = diagMissing();
                break;
            case "DiagTransfer":
                event = diagTransfer();
                break;
            case "DiagUnidentified":
                event = diagUnidentified();
                break;
            case "DiagOther":
                event = diagOther();
                break;

        }

        return event;
    }

    // PUBLIC METHODS HERE
    return {
        list: list,
        onDuty: onDuty,
        offDuty: offDuty,
        sleeper: sleeper,
        driving: driving,
        waitingAtSite: waitingAtSite,
        login: login,
        certify: certify,
        logout: logout,
        powerOff: powerOff,
        powerOn: powerOn,
        powerOffRp: powerOffRp,
        powerOnRp: powerOnRp,
        offRoad: offRoad,
        yardMoves: yardMoves,
        personalUse: personalUse,
        clearPCorYM: clearPCorYM,
        clearYM: clearYM,
        clearPC: clearPC,
        remark: remark,
        drivingEvents: drivingEvents,
        primaryEventStatus: primaryEventStatus,
        intermediateEvents: intermediateEvents,
        get: get
    };
};

export default eventTypes;
